import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable no-alert */
import { createContext, useContext, useEffect, useMemo, useReducer, useRef, } from 'react';
const fullscreenContextInit = {
    isFullScreen: false,
    toggle: () => { },
};
const FullscreenContext = createContext(fullscreenContextInit);
export function useFullscreen() {
    return useContext(FullscreenContext);
}
export function FullScreenProvider(props) {
    const [isFullScreen, toggle] = useReducer((value) => !value, false);
    const value = useMemo(() => ({ isFullScreen, toggle }), [isFullScreen, toggle]);
    return (_jsx(FullscreenContext.Provider, { value: value, children: _jsx(FullscreenInner, { ...props }) }));
}
function FullscreenInner(props) {
    const { children } = props;
    const { isFullScreen } = useFullscreen();
    const ref = useRef(null);
    useEffect(() => {
        if (isFullScreen && ref.current) {
            ref.current.requestFullscreen().catch(() => {
                alert('Fullscreen is not supported');
            });
        }
        else if (!isFullScreen &&
            ref.current &&
            document.fullscreenElement !== null &&
            document.exitFullscreen) {
            document.exitFullscreen().catch(() => {
                alert("Can't exit fullscreen");
            });
        }
    }, [isFullScreen]);
    return (_jsx("div", { ref: ref, style: {
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
        }, children: children }));
}
//# sourceMappingURL=FullscreenContext.js.map